import { VehicleAPI } from "@/api/vehicle.api";
import { AxiosObservable } from "axios-observable";

const api = new VehicleAPI();

const list = (): AxiosObservable<any> => {
  return api.list();
}

const listForExclusion = (): AxiosObservable<any> => {
  return api.listForExclusion();
}

const listForInclusion = (plate: string): AxiosObservable<any> => {
  return api.listForInclusion(plate);
}

const listOperationAreas = (): AxiosObservable<any> => {
  return api.listOperationAreas();
}

const listProducers = (): AxiosObservable<any> => {
  return api.listProducers();
}

const bodyModels = (): AxiosObservable<any> => {
  return api.bodyModels();
}

export default {
  list,
  listForExclusion,
  listForInclusion,
  listOperationAreas,
  listProducers,
  bodyModels
};
